import Axios from "@/plugins/Axios";
import PreMatricula from "@/Models/PreMatricula";

class PreMatriculasService {
  async buscarPorCpf(cpf) {
    const response = await Axios().post("matriculas/prematriculas/public/buscar-por-cpf", { cpf });
    return response.data;
  }

  async criarPreMatricula(dados) {
    const response = await Axios().post("matriculas/prematriculas/public", dados);
    const preMatricula = new PreMatricula(response.data);
    return preMatricula;
  }

  async listar(query = null, page = 1, perPage = 15) {
    const params = new URLSearchParams();
    if (query) params.append("query", query);
    params.append("page", page);
    params.append("per_page", perPage);

    const url = `matriculas/prematriculas?${params.toString()}`;
    const response = await Axios().get(url);

    const data = response.data.data || response.data;
    const prematriculas = (Array.isArray(data) ? data : []).map((pm) => new PreMatricula(pm));

    return {
      prematriculas,
      pagination: {
        currentPage: response.data.current_page || 1,
        perPage: response.data.per_page || perPage,
        total: response.data.total || prematriculas.length,
        lastPage: response.data.last_page || 1,
      },
    };
  }

  async buscarDuplicidades(cpf) {
    const response = await Axios().get(`matriculas/prematriculas/duplicidades?cpf=${cpf}`);
    const duplicidades = response.data.map((pm) => new PreMatricula(pm));
    return duplicidades;
  }

  async matricular(prematriculaId) {
    const response = await Axios().post(`matriculas/prematriculas/${prematriculaId}/matricular`);
    return response.data;
  }

  async excluir(prematriculaId) {
    const response = await Axios().delete(`matriculas/prematriculas/${prematriculaId}`);
    return response.data;
  }

  async excluirDuplicidades(cpf, manterPrematriculaId) {
    const response = await Axios().post("matriculas/prematriculas/excluir-duplicidades", {
      cpf,
      manter_prematricula_id: manterPrematriculaId,
    });
    return response.data;
  }

  async listarEscolasPublico() {
    const response = await Axios().get("matriculas/prematriculas/public/escolas");
    return response.data;
  }

  async listarTurmasPublico() {
    const response = await Axios().get("matriculas/prematriculas/public/turmas");
    return response.data;
  }

  async listarSeriesPublico() {
    const response = await Axios().get("matriculas/prematriculas/public/series");
    return response.data;
  }

  async listarSeriesPorTurma(turmaId) {
    const response = await Axios().get(`matriculas/prematriculas/public/turmas/${turmaId}/series`);
    return response.data;
  }

  async listarSexosPublico() {
    const response = await Axios().get("matriculas/prematriculas/public/sexos");
    return response.data;
  }

  async listarEstadosPublico() {
    const response = await Axios().get("matriculas/prematriculas/public/estados");
    return response.data;
  }
}

export default new PreMatriculasService();
